<template>
  <div>
    <el-dialog v-model="insertDialog" title="新增任务" width="1100">
      <div>
        <el-form :model="insertData" ref="insertRules" label-width="100px" class="demo-ruleForm">
          <div style="padding-right: 50px">
            <el-row>
              <el-col :span="6">
                <el-form-item  prop="coachId" label="老师" :rules="{ required: true, message: '请选择', trigger: 'blur'}">
                  <el-select style="width: 170px"
                             v-model="insertData.coachId"
                             clearable @change="changeCoach"
                             filterable="true" remote="true"
                             :remote-method="fetchCoachList"
                  >
                    <el-option v-for="item in coachList" :key="item.coachid" :label="item.coachname" :value="item.coachid"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所属月份" prop="date" :rules="{ required: true, message: '请选择', trigger: 'blur'}">
                  <el-date-picker type="month" style="width:170px" value-format="YYYY/MM" v-model="insertData.date"
                                  placeholder="请选择">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所属榜单" prop="type" :rules="{ required: true, message: '请选择', trigger: 'blur'}">
                  <el-select placeholder="请选择" style="width: 170px;" v-model="insertData.type">
                    <div>
                      <el-option label="最强新人榜" value="1"></el-option>
                      <el-option label="焱火英雄榜" value="2"></el-option>
                      <el-option label="区域英雄榜" value="3"></el-option>
                    </div>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="榜单类型" prop="title" :rules="{ required: true, message: '请输入', trigger: 'blur'}">
                  <el-input style="width: 170px" v-model="insertData.title" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
          </el-row>
          </div>
          <div style="display: flex;justify-content: center;margin-top: 10px">
            <el-row>
              <div style="background-color:#981d22;width: 900px;top: 190px;padding: 10px;overflow: auto;border-radius: 10px">
                <div style="display: flex">
                  <div style="width:40%;display: flex;justify-content: center;flex-wrap: wrap">
                    <el-image v-if="insertData.coach.portrait" class="coach-image" :src="insertData.coach.portrait"></el-image>
                    <el-image v-else class="coach-image" src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80"></el-image>
                    <div style="width: 100%;background-color: #b83a3d;padding: 10px;border-radius: 6px;margin-top: 10px">
                      <div class="textarea-input">
                        <el-form-item label-width="0px" prop="introduce" :rules="{ required: true, message: '请输入', trigger: 'blur'}">
                          <el-input v-model="insertData.introduce" :rows="2" type="textarea" placeholder="请输入简介"/>
                        </el-form-item>
                      </div>
                      <div class="textarea-input">
                        <el-form-item label-width="0px" prop="saying" :rules="{ required: true, message: '请输入', trigger: 'blur'}">
                          <el-input v-model="insertData.saying" :rows="2" type="textarea" placeholder="请输入格言"/>
                        </el-form-item>
                      </div>
                      <div class="textarea-input">
                        <el-form-item label-width="0px" prop="honoraryTitle" :rules="{ required: true, message: '请输入', trigger: 'blur'}">
                          <el-input v-model="insertData.honoraryTitle" :rows="2" type="textarea" placeholder="请输入称号"/>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div style="width: 80px"></div>
                  <div>
                    <div class="coach-name">{{insertData.coach.coachname}}的辉煌焱火路</div>
                    <div>
                      <div v-for="(item,index) in insertData.details" :key="index" style="display: flex;align-items: center;font-size: 12px;">
                        <div style="color: #b63134;font-size: 60px">➡</div>
                        <div class="textarea-container">
                          <el-input v-model="item.detail" :rows="4" type="textarea" placeholder="请输入"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-row>
          </div>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="insertDialog = false">取 消</el-button>
          <el-button type="primary" @click="insert">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {getListCoachAll} from "@/api/workphone";
import {createHonor} from "@/api/coach"
export default {
  name: "CreateHonor",
  data() {
    return {
      insertData:{
        coach:{},
        date:null,
        year:null,
        month:null,
        title:null,
        honoraryTitle:null,
        introduce:null,
        saying:null,
        details:[{detail:""}]
      },
      insertDialog:false
    }
  },
  methods: {
    insert(){
      this.$refs['insertRules'].validate(async (valid) => {
        if (!valid){return;}
        const [year, month] = this.insertData.date.split('/');
        this.insertData.year = year;
        this.insertData.month = month;
        createHonor(this.insertData).then(val=>{
          if (val.code == 200) {
            this.$emit('success');
            this.insertDialog=false;
            this.$message.success("添加成功！");
          } else {
            this.$message.error("添加失败！");
          }
        })
      })
    },
    openDialog(){
      this.insertDialog = true;
    },
    // 获取教练列表
    fetchCoachList(name) {
      getListCoachAll({
        keyword: name || "", // 关键字参数
      }).then(res => {
        if (res.code === 200) {
          this.coachList = res.data
        } else {
          this.$message.error(`请求校区负责人失败！`);
        }
      })
    },
    changeCoach(id){
      this.insertData.coach = this.coachList.find(item => item.coachid === id);
    },
  },
  created() {
    getListCoachAll({
      keyword: name || "", // 关键字参数
    }).then(res => {
      if (res.code === 200) {
        this.coachList = res.data
      } else {
        this.$message.error(`请求校区负责人失败！`);
      }
    })
  }
}
</script>

<style scoped>
.coach-image{
  margin-top: 10px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #c25c52;
  padding: 6px;
  overflow: hidden;
}
.coach-image :deep(img) {
  width: 100%;
  height: 100%;
  border-radius: 50% !important; /* 强制覆盖 img 原有样式 */
  object-fit: cover; /* 可选：让图片自适应容器，不拉伸变形 */
}
.coach-name{
  color: #f5da86;
  font-style: italic;
  font-size: 30px;
  text-align: center;
  margin-bottom: 10px;
}
/* 核心：统一使用 :deep() + 增加 !important 提升优先级（解决样式覆盖问题） */
.textarea-container :deep(.el-textarea__inner) {
  background-color: #c25c4f !important;
  color: white !important;
  padding: 6px 8px !important;
  font-size: 12px !important;
  border-radius: 2px !important;
  margin: 6px 0 !important;
  width: 400px !important;
  /* 1. 只保留一次 border 定义，避免重复覆盖 */
  border: none !important;
  /* 2. 清除焦点时的外边框（这是白色边框的核心元凶） */
  outline: none !important;
  /* 3. 清除 Element UI 内置的 box-shadow（部分版本会有） */
  box-shadow: none !important;
  /* 4. 可选：清除禁用/hover 等状态的边框（兜底） */
  border-color: transparent !important;
}
.textarea-container :deep(.el-textarea__inner)::placeholder {
  color: white !important; /* 白色半透明，可自定义 */
  opacity: 1 !important; /* 解决部分浏览器 placeholder 透明度默认偏低的问题 */
  font-size: 12px !important; /* 可选：统一 placeholder 字体大小 */
}
.textarea-input :deep(.el-textarea__inner)::placeholder {
  color: white !important; /* 白色半透明，可自定义 */
  opacity: 1 !important; /* 解决部分浏览器 placeholder 透明度默认偏低的问题 */
  font-size: 12px !important; /* 可选：统一 placeholder 字体大小 */
}
.textarea-input :deep(.el-textarea__inner) {
  background-color: #c25c4f !important;
  color: white !important;
  padding: 6px 8px !important;
  margin: 6px 0 !important;
  font-size: 12px !important;
  border-radius: 2px !important;
  width: 100% !important;
  /* 1. 只保留一次 border 定义，避免重复覆盖 */
  border: none !important;
  /* 2. 清除焦点时的外边框（这是白色边框的核心元凶） */
  outline: none !important;
  /* 3. 清除 Element UI 内置的 box-shadow（部分版本会有） */
  box-shadow: none !important;
  /* 4. 可选：清除禁用/hover 等状态的边框（兜底） */
  border-color: transparent !important;
}
</style>